import React, { useState } from 'react';
import { Tab } from '@headlessui/react';
import {
  CubeIcon,
  UserGroupIcon
} from '@heroicons/react/24/outline';
import ProductList from './ProductList';
import FreeAccountsList from './FreeAccountsList';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const ProductManagement: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const tabs = [
    {
      name: 'Products',
      icon: CubeIcon,
      component: ProductList
    },
    {
      name: 'Free Accounts',
      icon: UserGroupIcon,
      component: FreeAccountsList
    }
  ];

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">Product Management</h1>
          <p className="text-slate-400">Manage products, pricing, features, and free accounts</p>
        </div>
      </div>

      {/* Tabs */}
      <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        <Tab.List className="flex space-x-2 rounded-xl bg-slate-800/50 p-1 backdrop-blur-sm border border-slate-700/50">
          {tabs.map((tab) => (
            <Tab
              key={tab.name}
              className={({ selected }) =>
                classNames(
                  'w-full rounded-lg py-3 px-4 text-sm font-medium leading-5 transition-all duration-200',
                  'ring-white ring-opacity-60 ring-offset-2 ring-offset-slate-900 focus:outline-none focus:ring-2',
                  selected
                    ? 'bg-gradient-to-br from-indigo-500 to-purple-600 text-white shadow-lg'
                    : 'text-slate-400 hover:bg-slate-700/50 hover:text-white'
                )
              }
            >
              <div className="flex items-center justify-center space-x-2">
                <tab.icon className="h-5 w-5" />
                <span>{tab.name}</span>
              </div>
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mt-6">
          {tabs.map((tab, idx) => (
            <Tab.Panel
              key={idx}
              className={classNames(
                'rounded-xl',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-slate-900 focus:outline-none'
              )}
            >
              <tab.component />
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ProductManagement;
